module.exports = __webpack_public_path__ + "static/media/facebook-ads-dieet-club.5497b8dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook-ads-dieet-club.png
// module id = 189
// module chunks = 0